// first: no eval in the browser (before any schema is made)
import '@london-life/api-client/no-eval';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { applyDesignTokens } from '@london-life/ui/design';
import '@london-life/ui/styles.css';
import './admin.css';
import { ErrorBoundary } from '@london-life/ui/feedback/error-boundary';
import { App } from './app';

applyDesignTokens(document.documentElement);
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
